var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"dense":""}},[_c('v-list-item-action',[_c('v-checkbox',{key:_vm.entry.id,attrs:{"input-value":_vm.checked},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.checked = !_vm.checked}}})],1),_c('v-list-item-title',[_vm._v(_vm._s(_vm.entry.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }